import BackgroundColors from '@root/joinroot.com/src/utils/background-colors';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function ExpandableSection({
  anchor,
  children,
  backgroundColor,
}) {
  return (
    <section
      css={[
        styles.section,
        styles.anchorSpacer,
        BackgroundColors.getBackgroundStyle(backgroundColor),
      ]}
      id={anchor}
    >
      {children}
    </section>
  );
}

ExpandableSection.propTypes = {
  anchor: PropTypes.string,
  backgroundColor: PropTypes.oneOf(BackgroundColors.cmsValueList),
  children: PropTypes.node.isRequired,
};

const styles = StyleSheet.create({
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: '100px 20px',

    ...Responsive.sm({
      padding: '100px 30px',
    }),
  },
  anchorSpacer: {
    '&:before': {
      display: 'block',
      content: '" "',
      marginTop: -110,
      height: 110,
      visibility: 'hidden',
      pointerEvents: 'none',
    },
  },
});
